import type {BackendConfig, BackendConfigList} from '../types'

const prod: BackendConfig = {
  AUTH_URL: 'https://auth.hconnect.digital',
  API_URL: 'https://api.hconnect.heidelbergcement.com',
  MHC_URL: 'https://manage.hconnect.digital'
}

const qa: BackendConfig = {
  AUTH_URL: 'https://auth-qa.hconnect.digital',
  API_URL: 'https://api-qa.hconnect.heidelbergcement.com',
  MHC_URL: 'https://manage-qa.hconnect.digital'
}

const uat: BackendConfig = {
  AUTH_URL: 'https://auth-uat.hconnect.digital',
  API_URL: 'https://api-uat.hconnect.heidelbergcement.com',
  MHC_URL: 'https://manage-uat.hconnect.digital'
}

const regression: BackendConfig = {
  AUTH_URL: 'https://auth-regression.hconnect.digital',
  API_URL: 'https://api-regression.hconnect.heidelbergcement.com',
  MHC_URL: 'https://manage-regression.hconnect.digital'
}

const dev: BackendConfig = {
  AUTH_URL: 'http://localhost:4000?backend=dev',
  API_URL: 'https://api-dev.hconnect.heidelbergcement.com',
  MHC_URL: 'https://manage-dev.hconnect.digital'
}

const local: BackendConfig = {
  AUTH_URL: 'http://localhost:4000?backend=dev',
  API_URL: 'http://localhost:9000',
  MHC_URL: 'http://localhost:3002'
}

const origin: BackendConfig = {
  AUTH_URL: 'http://localhost:4000?backend=dev',
  API_URL: window.location.origin + '/api',
  MHC_URL: 'http://localhost:3002?backend=dev'
}

const uatr: BackendConfig = {
  AUTH_URL: 'https://auth-uatr.hconnect.digital',
  API_URL: 'https://api-uat-readonly.hconnect.heidelbergcement.com',
  MHC_URL: 'https://manage-uatr.hconnect.digital'
}

// That backend is special:
// It's a test environment for multi-cluster deployments
const dpTest: BackendConfig = {
  AUTH_URL: 'https://auth-dptest.hconnect.digital',
  API_URL: 'https://dptest.heidelbergcement.com',
  MHC_URL: 'https://manage-dptest.hconnect.digital'
}

const LOCAL_AUTH_ADDR = 'http://localhost:4000'
const LOCAL_MHC_ADDR = 'http://localhost:3002'

const prodLocal: BackendConfig = {
  ...prod,
  AUTH_URL: `${LOCAL_AUTH_ADDR}?backend=prod`,
  MHC_URL: `${LOCAL_MHC_ADDR}?backend=prod`
}

const qaLocal: BackendConfig = {
  ...qa,
  AUTH_URL: `${LOCAL_AUTH_ADDR}?backend=qa`,
  MHC_URL: `${LOCAL_MHC_ADDR}?backend=qa`
}

const uatLocal: BackendConfig = {
  ...uat,
  AUTH_URL: `${LOCAL_AUTH_ADDR}?backend=uat`,
  MHC_URL: `${LOCAL_MHC_ADDR}?backend=uat`
}

const uatrLocal: BackendConfig = {
  ...uat,
  AUTH_URL: `${LOCAL_AUTH_ADDR}?backend=uatr`,
  MHC_URL: `${LOCAL_MHC_ADDR}?backend=uatr`
}

const regressionLocal: BackendConfig = {
  ...regression,
  AUTH_URL: `${LOCAL_AUTH_ADDR}?backend=regression`,
  MHC_URL: `${LOCAL_MHC_ADDR}?backend=regression`
}

export function getDefaultDFBackends(): BackendConfigList {
  if (process.env.REACT_APP_STAGE === 'prod') {
    return {prod}
  }
  return {
    local,
    dpTest,
    dev,
    qa,
    qaLocal,
    uat,
    uatLocal,
    uatr,
    uatrLocal,
    regressionLocal,
    regression,
    prod,
    prodLocal,
    origin
  }
}

export const getLocalBackend = (): BackendConfigList => ({local})
export const getQABackend = (): BackendConfigList => ({qa})
export const getUATBackend = (): BackendConfigList => ({uat})
export const getUATReadonlyBackend = (): BackendConfigList => ({uat})
export const getRegressionBackend = (): BackendConfigList => ({regression})
export const getPRODBackend = (): BackendConfigList => ({prod})
